import { forwardRef } from 'react'

import { Polymorphic } from '../../../utils/PolymorphicUtils'
import { Container } from '../../shared/container/container'
import { Stack } from '../../shared/stack/Stack'
import { HeaderBrand, HeaderBrandProps } from './header-brand'
import { HeaderLanguageSwitch } from './header-language-switch'
import {
  HeaderThemeSwitch,
  HeaderThemeSwitchProps,
} from './header-theme-switch'

type HeaderProps = HeaderBrandProps & HeaderThemeSwitchProps

export const Header = forwardRef(function Header(
  { title, isDarkTheme, onToggleTheme, ...props },
  ref,
) {
  return (
    <Container
      as="nav"
      className="py-8 z-10 relative w-full print:hidden"
      {...props}
      ref={ref}
    >
      <Stack align="center" justify="space-between">
        <HeaderBrand title={title} />
        <Stack align="center" gap={4 * 4}>
          <HeaderLanguageSwitch />
          <HeaderThemeSwitch
            isDarkTheme={isDarkTheme}
            onToggleTheme={onToggleTheme}
          />
        </Stack>
      </Stack>
    </Container>
  )
}) as Polymorphic<'nav', HeaderProps>
